import { DeviceForm } from "@/components/DeviceForm";
import { TrialDeviceForm } from "@/components/TrialDeviceForm";
import { Action } from "@/models/actions/Action";
import { ActionControls } from "@/models/actions/ActionControls";
import { Device } from "@/models/Device";
import { TrialDevice } from "@/models/Trial";
import { notification } from "antd";

export class NewTrialDeviceAction implements Action {
	constructor(private readonly device?: TrialDevice) {}

	getOptions() {
		return {
			width: "40vw",
			title: this.device ? "Editar equipamento trial" : "Adicionar equipamento trial",
		};
	}

	render(controls: ActionControls) {
		return (
			<TrialDeviceForm
				trialDevice={this.device}
				onSubmitting={() => controls.setCloseable(false)}
				onSubmitted={() => this.onSuccess(controls)}
				onSubmissionFailed={(error) => this.onFailure(error, controls)}
			/>
		);
	}

	private onSuccess(controls: ActionControls) {
		controls.setCloseable(true);
		controls.close();

		notification.success({ message: "Equipamento salvo com sucesso!" });
	}

	private async onFailure(error: any, controls: ActionControls) {

		console.log(error);

		if (error?.response?.status === 406) {
			const errorMessage = await error?.response.json()
			controls.setCloseable(true);
			notification.error({ message: errorMessage.message });
			return
		}
		controls.setCloseable(true);

		notification.error({ message: "Erro ao salvar equipamento" });
	}
}
